import React, { useState } from 'react';
import apiClient from '../../utils/apiClient';
import { imageBaseurl } from '../../utils/common';

const FileUploader = () => {
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');
    const [uploadUrl, setUploadUrl] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile && selectedFile.type.startsWith('image/')) {
            setPreviewUrl(URL.createObjectURL(selectedFile));
        } else if (selectedFile && selectedFile.type.startsWith('text/')) {
            const reader = new FileReader();
            reader.onload = () => setPreviewUrl(reader.result);
            reader.readAsText(selectedFile);
        } else {
            setPreviewUrl('');
        }
    };

    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopy = (url, index) => {
      navigator.clipboard.writeText(url);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 1500); // Hide after 1.5 seconds
    };

    const handleUpload = async () => {
        if (!file) return alert('Please select a file first!');
        setLoading(true);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await apiClient.post(`/blog/upload-file`, formData, { headers: { "Content-Type": "multipart/form-data" } });


            setUploadUrl([...uploadUrl ,imageBaseurl + res.data.url]);
            alert('File uploaded successfully!');
        } catch (err) {
            console.error(err);
            alert('Upload failed!');
        } finally {
            setLoading(false);
            setFile(null)
        }
    };
return null
    return (
        <div style={{ padding: 20, margin: 'auto' }}>
            <h2>Upload a File</h2>

            <input type="file" onChange={handleFileChange} />

            {previewUrl && (
                <div style={{ marginTop: 10 }}>
                    <h4>Preview:</h4>
                    {file?.type?.startsWith('image/') ? (
                        <img src={previewUrl} alt="Preview" style={{ maxWidth: '100%' }} />
                    ) : (
                        <pre style={{ background: '#f0f0f0', padding: 10 }}>{previewUrl}</pre>
                    )}
                </div>
            )}

            <button onClick={handleUpload} disabled={loading} style={{ marginTop: 20 }}>
                {loading ? 'Uploading...' : 'Upload'}
            </button>

            <p>Uploaded URL:</p>{' '}
            {uploadUrl.map((res, index) =>
                <div style={{ marginTop: 20 }} key={index}>
                    <a href={res} target="_blank" rel="noreferrer">{res}</a>  <button onClick={() => handleCopy(res, index)}>Copy</button>
          {copiedIndex === index && <span style={{ color: 'green' }}>Copied!</span>}
                </div>)
            }
        </div>
    );
};

export default FileUploader;
